/**
 * The pause menu.
 *
 * It used to *be* the settings, which is how Esc came to mean "open settings" -
 * a thing no other game means by it. Esc stops the run and gives the mouse
 * back; what to do next is a list of buttons, and the settings are one of them.
 *
 * The overlay deliberately does not swallow clicks: a click on the backdrop
 * falls through to the canvas, which re-grabs pointer lock and resumes. That is
 * the fastest way back into a run and it predates the buttons.
 *
 * The list is walkable with the arrows and pressable with Enter, like the front
 * page's - this is the screen the mouse has just been taken away from, and
 * asking for it back to press JATKA is the wrong thing to ask for.
 */

import { MenuButtons } from './MenuButtons';
import { button, el, setHidden } from './dom';

export interface PauseScreenActions {
  resume: () => void;
  openSettings: () => void;
  openResults: () => void;
  openHelp: () => void;
  restart: () => void;
}

export class PauseScreen {
  readonly root = el('div', 'overlay overlay--menu');
  /** Menu actions for the arrows and Enter. See `Game.keyboardMenu`. */
  readonly buttons: MenuButtons;

  constructor(actions: PauseScreenActions) {
    const panel = el('div', 'menu__pause');
    const nodes = [
      button('JATKA', () => actions.resume(), 'btn btn--primary'),
      button('TULOKSET', () => actions.openResults()),
      button('ASETUKSET', () => actions.openSettings()),
      button('OHJEET', () => actions.openHelp()),
      button('UUSI YRITYS', () => actions.restart(), 'btn', 'R'),
    ];
    this.buttons = new MenuButtons(nodes);

    const row = el('div', 'menu__actions');
    row.append(...nodes);

    panel.append(
      el('p', 'menu__eyebrow', 'YRITYS ODOTTAA'),
      el('h1', 'menu__title menu__title--small', 'TAUKO'),
      el('div', 'menu__rule menu__rule--center'),
      row,
      el(
        'p',
        'menu__hint',
        'NUOLET valitsevat, ENTER vahvistaa. Klikkaus valikon ulkopuolelle jatkaa myös.',
      ),
    );

    this.root.appendChild(panel);
  }

  mount(parent: HTMLElement): void {
    parent.appendChild(this.root);
  }

  setVisible(visible: boolean): void {
    setHidden(this.root, !visible);
    this.buttons.setActive(visible);
  }
}
